import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { Grade } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class GradeService extends TmsWebBaseEditService<Grade, Grade> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('Grade', $localize`Grade`, httpService, notificationService);
  }
}
